<div class="vip-change-card-root" *transloco="let t">
  <div class="content">
    <div class="header">
      <span class="header-content">{{ t('update-vip-level') }}</span><br>
      <button id="close-modal-icon" (click)="onFailClick()" mat-icon-button class="close-button">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
    <div [formGroup]="formGroup" class="center">
        <div class="vip-selector">
          <div class="radio-button">
            <input  type="radio"
                    id="starting-today"
                    name="starting-text"
                    value=1
                    (change)="onRadioButtonChange($event)"
                    [formControl]="getControl('season')">
            <label for="starting-today">{{ t('starting-today') }} ({{today}})</label>
          </div>
          <div class="radio-button">
            <input type="radio"
                    id="starting-next"
                    name="starting-text"
                    value=2
                    (change)="onRadioButtonChange($event)"
                    [formControl]="getControl('season')">
            <label for="starting-next">{{ t('starting-next') }} ({{nextSeasonStartingDate}})</label>
          </div>
          <app-select id="vip-change-list-input"
            [control]="getControl('level')"
            [label]="t('vip-level')"
            [options]="options"
            [optionAccessor]="businessLevelName"
            [disabled]="this.options.length === 0"
            required>
          </app-select>
        </div>
      <app-input id="vip-change-reseller"
        input
        [control]="getControl('reseller')"
        [label]="t('reseller')">
      </app-input>
    </div>
    <div class="bottom-area">
      <app-primary-button id="fail-dialog-btn"
            class="clear-button"
            (click)="onFailClick()">
        {{ 'cancel' | transloco }}
      </app-primary-button>
      <app-primary-button class="success-button"
        id="success-dialog-btn"
        [disabled]="isUpdateButtonDisabled() || loading"
        (clickAction)="onSuccessClick()">
          {{ 'update-vip-level' | transloco }}
      </app-primary-button>
    </div>
  </div>
</div>
